import React, { Component } from "react";
import {networkResetDeviceActions as networkResetDeviceAction} from "../../../actions/network-reset-device.actions";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {claimTypes} from "../../../constants/claim.constants";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {withNamespaces} from "react-i18next";
import NetworkResetDeviceTable from "./_components/NetworkResetDeviceTable";

class NetworkResetDevicePage extends Component {

    constructor(props) {
        super(props);

        if(!localStorage.getItem('device-reset-view')) {
            localStorage.setItem('device-reset-view', "list");
        }
    }

    interval = null;

    state = {

    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(networkResetDeviceAction.getNetworkResetDeviceList());
        this.updateStore();
    }

    componentWillUnmount() {
        if(this.interval) {
            clearInterval(this.interval)
        }
    }

    updateStore = () => {
        const { dispatch, lockRefresh } = this.props;

        if(!lockRefresh) {
            dispatch(networkResetDeviceAction.getNetworkResetDeviceList());
        }
        if(!this.interval) {
            this.interval = setInterval(this.updateStore, 5000);
        }
    }

    render() {
        const { t, resetDevice, user } = this.props;
        const crudPermission            = user[`c_network-device.actions.crud`] || null;
        const diagnosticModePermission  = user[`c_network-device.actions.diagnostic-mode`] || null;


        const breadcrumb = [
            { value: 'network-device', path: "#" }
        ];

        return (
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <h4>{ t('network-reset-device') }</h4>
                <div className="card">
                    <div className="card-header">
                        <div className="button-group">
                            { crudPermission === claimTypes.READ_WRITE ? (
                                <Link to="/panel/network-reset-device/create" className="btn btn-success float-right btn-create mt-2 mt-sm-0">
                                    <i className="fas fa-plus"> </i> &nbsp; { t('create') }
                                </Link>
                            ) : (<React.Fragment/>) }
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row my-2">
                            <NetworkResetDeviceTable list={resetDevice} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    const { list, lockRefresh } = state.networkResetDeviceReducer;
    const { user } = state.authenticationReducer;
    return {
        resetDevice: list,
        user,
        lockRefresh

    }
};
export default withNamespaces()(connect(mapStateToProps)(NetworkResetDevicePage));
